import React, { useState, useEffect } from 'react';
import './OfflineDetector.css';

const OfflineDetector = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowMessage(true);
      setTimeout(() => setShowMessage(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowMessage(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Check initial state
    if (!navigator.onLine) {
      setShowMessage(true);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showMessage) return null;

  return (
    <div className={`offline-detector ${isOnline ? 'online' : 'offline'}`}>
      <div className="offline-detector-content">
        {isOnline ? (
          <>
            <i className="fa fa-wifi"></i>
            <span>Back Online</span>
          </>
        ) : (
          <>
            <i className="fa fa-wifi-slash"></i>
            <span>No Internet Connection</span>
          </>
        )}
      </div>
    </div>
  );
};

export default OfflineDetector;
